import React, { Component } from 'react';
import { Field, Formik } from 'formik';
import { TextField } from '@material-ui/core';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { resetPasswordAction } from '../../../modules/auth/Actions';
import { castArray } from 'lodash';
import * as Yup from 'yup';
import { newErrorNotificationAction } from '../../../modules/notifications/Actions';
import getLangData from '../../../utils/getLangData';

const schema = () =>
  Yup.object({
    password: Yup.string()
      .required(getLangData().fields.required)
      .default(''),
    passwordConfirmation: Yup.string()
      .default('')
      .oneOf(
        [Yup.ref('password'), null],
        getLangData().general_words.match_password
      )
  });

class ResetPassword extends Component {
  // to validate Passowrd

  validatePassword = values => {
    let error = '';
    const passwordRegex = /(?=.*[0-9])/;
    if (!values) {
      error = '*Required';
    } else if (values.length < 8) {
      error = '*Password must be 8 characters long.';
    } else if (!passwordRegex.test(values)) {
      error = '*Invalid password. Must contain one number.';
    }
    return error;
  };

  // to confirm passwords are similar

  validateConfirmPassword = (pass, value) => {
    let error = '';
    if (pass && value) {
      if (pass !== value) {
        error = 'Password not matched';
      }
    }
    return error;
  };
  state = { isRequested: false };
  render() {
    const { intl, resetPassword, errorAction, match } = this.props;
    const { isRequested } = this.state;

    if (isRequested) {
      return <Redirect to='/auth' />;
    }

    return (
      <div className='kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper'>
        <div className='kt-login__body'>
          <div className='kt-login__form'>
            <div className='kt-login__title'>
              <h3>{getLangData().buttons.reset_password}</h3>
            </div>

            <Formik
              initialValues={schema().cast()}
              // validate={(values) => {
              //   const errors = {};

              //   if (!values.password) {
              //     errors.password = intl.formatMessage({
              //       id: 'AUTH.VALIDATION.getLangData().fields.required',
              //     });
              //   } else if (
              //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
              //   ) {
              //     errors.password = intl.formatMessage({
              //       id: 'AUTH.VALIDATION.INVALID_FIELD',
              //     });
              //   }

              //   return errors;
              // }}

              validate={this.validateConfirmPassword}
              onSubmit={async (values, { setStatus, setSubmitting }) => {
                const token = match.params.token;
                if (values.password !== values.passwordConfirmation) {
                  errorAction('Password Does Not Match');
                } else if (values.password === values.passwordConfirmation) {
                  setSubmitting(true);
                  try {
                    await resetPassword(token, values.password);
                  } catch (err) {
                    console.log(err);
                  } finally {
                    setSubmitting(false);
                  }
                }
              }}
            >
              {({
                values,
                status,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting
              }) => (
                <form onSubmit={handleSubmit} className='kt-form'>
                  {status && (
                    <div role='alert' className='alert alert-danger'>
                      <div className='alert-text'>{status}</div>
                    </div>
                  )}

                  <div className='form-group'>
                    <Field
                      as={TextField}
                      type='password'
                      label={getLangData().fields.password}
                      margin='normal'
                      fullWidth={true}
                      name='password'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      // validate={this.validatePassword}
                      value={values.password}
                      error={errors.password}
                      // error={Boolean(touched.password && errors.password)}
                    />{' '}
                  </div>
                  <div className='form-group'>
                    <Field
                      as={TextField}
                      type='password'
                      label={getLangData().fields.confirm_Password}
                      margin='normal'
                      fullWidth={true}
                      name='passwordConfirmation'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.passwordConfirmation}
                      helperText={
                        touched.passwordConfirmation &&
                        errors.passwordConfirmation
                      }
                      validate={value => {
                        this.validateConfirmPassword(values.password, value);
                      }}
                      // error={Boolean(
                      //   touched.passwordConfirmation &&
                      //     errors.passwordConfirmation
                      // )}
                      error={errors.passwordConfirmation}
                    />{' '}
                  </div>

                  <div className='kt-login__actions'>
                    <Link to='/auth'>
                      <button
                        type='button'
                        className='btn btn-secondary btn-elevate kt-login__btn-secondary'
                      >
                        {getLangData().buttons.back}
                      </button>
                    </Link>

                    <button
                      type='submit'
                      className='btn btn-primary btn-elevate kt-login__btn-primary'
                      disabled={isSubmitting}
                    >
                      {getLangData().buttons.submit}
                    </button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    );
  }
}

// export default injectIntl(ForgotPassword);
const mapStateToProps = (state, props) => {
  return {};
};

export default injectIntl(
  connect(mapStateToProps, {
    resetPassword: resetPasswordAction,
    errorAction: newErrorNotificationAction
  })(ResetPassword)
);
